export default class QuitAssessmentModalController {
    /**
     * Constructor for the QuitAssessmentModalController class.
     * Initializes the controller with dependencies and sets up initial state.
     * 
     * @param {Object} $scope - AngularJS scope object.
     * @param {Object} $uibModalInstance - Instance of the modal dialog.
     * @param {Object} $bridges - Bridges service for various utilities.
     * @param {Object} $location - AngularJS $location service.
     * @param {Object} $timeout - AngularJS $timeout service.
     * @param {Object} $filter - AngularJS $filter service.
     * @param {Object} $translate - AngularJS $translate service.
     * @param {Object} UserInfoService - Service for user information.
     * @param {Object} TaskCountdownService - Service for task countdown.
     * @param {Object} TaskInfoService - Service for task information.
     * @param {boolean} quitEarly - Flag indicating if quitting early.
     * @param {string} eventId - ID of the event.
     */
    constructor($scope, $uibModalInstance, $bridges, $location, $timeout, $filter, $translate, UserInfoService, TaskCountdownService, TaskInfoService, quitEarly, eventId) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.$bridges = $bridges;
        this.$location = $location;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$translate = $translate;
        this.UserInfoService = UserInfoService;
        this.TaskCountdownService = TaskCountdownService;
        this.TaskInfoService = TaskInfoService;
        this.quitEarly = quitEarly;
        this.eventId = eventId;

        this.$logger = $bridges.logger();
        this.$eventLog = $bridges.eventLog();
        this.$auth = $bridges.authentication();
        this.candidateUUID = this.$auth.getUserUUID();
        this.candidate = UserInfoService.getUserInfo(this.candidateUUID);
        this._taskCountdown = TaskCountdownService.getInstance();

        this.$scope._logIdentifier = 'QuitAssessmentModalController';
        this.$logger.logEnter(this.$scope, 'initialisation');

        this.$scope.explanationMinChar = 0;
        this.$scope.eventExplanation = "";
        this.$scope.disabledQuitBtn = true;
        this.$scope.quitEarly = quitEarly;
        this.$scope.eventId = eventId;

        console.log("quit early", quitEarly);

        this.eventTypes = angular.copy(TaskInfoService.getTaskInfo().getEventTypes());

        if (!quitEarly) {
            this.filteredEventType = $filter('filter')(this.eventTypes, { id: 'finishEarlyByInvigilator' }, true)[0];
        } else {
            this.filteredEventType = $filter('filter')(this.eventTypes, { id: 'leavePackageEarlyByInvigilator' }, true)[0];
        }

        if (angular.isDefined(this.filteredEventType) && this.filteredEventType.explanatoryNote === 'mandatory') {
            this.$scope.explanationMinChar = 1;
            this.$scope.disabledQuitBtn = true;
        }

        this.$scope.$watch('eventExplanation', this.onEventExplanationChange.bind(this));
        this.$scope.onQuit = this.onQuit.bind(this);
    }

    /**
     * Watches for changes in the event explanation text and updates the state of the quit button.
     */
    onEventExplanationChange() {
        if (this.$scope.eventExplanation === '' || this.$scope.explanationMinChar === 0) {
            this.$scope.disabledQuitBtn = false;
            return;
        }

        if (this.$scope.eventExplanation && this.$scope.eventExplanation.length >= this.$scope.explanationMinChar) {
            this.$timeout(() => {
                this.$scope.$apply(() => {
                    this.$scope.disabledQuitBtn = false;
                });
            }, 1);
        } else {
            this.$scope.disabledQuitBtn = true;
        }
    }

    /**
     * Handles the quit action. Logs the event and performs necessary actions based on whether quitting early or not.
     */
    onQuit() {
        if (!this.$scope.disabledQuitBtn) {
            console.log("finishEarlyByInvigilator");

            this.$uibModalInstance.close();

            if (!this.quitEarly) {
                console.info('(Finish Early) Response File will be prepared before quitting the eAssessment');
                this.$eventLog.logEvent(this.$translate.instant('MODULES.ADMIN.EVENTLOG_FINISH_EARLY_BY_INVIGILATOR'), "finishEarlyByInvigilator", this.$scope.eventExplanation, '', {});

                this._taskCountdown.setTaskExpired();
                this.$location.path('/taskdone/' + this.$bridges.authentication().getUserUUID());
            } else {
                console.log("Early Quit! Leaving Package");
                this.$eventLog.logEvent(this.$translate.instant('MODULES.ADMIN.EVENTLOG_LEAVE_PACKAGE_BY_INVIGILATOR'), "leavePackageEarlyByInvigilator", this.$scope.eventExplanation, '', {});

                this.$bridges.runtime().quit(false, false);
            }
        }
    }
}